export const MERCHANT_FILTER = 'MERCHANTS/filter';
export const MERCHANT_API_KEY = 'MERCHANTS/api_key';
export const MERCHANT_API_KEY_LIST = 'MERCHANTS/api_key_list';
export const MERCHANT_API_KEY_ITEM = 'MERCHANTS/api_key_item';
export const MERCHANT_API_KEY_REGENERATE = 'MERCHANTS/api_key_item_regenerate';
